var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRegistry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "registry_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13.143,
    width: 36,
    height: 6.923,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13.143,
    width: 36,
    height: 6.923,
    rx: 1,
    stroke: "#4F6BCB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    mask: "url(#registry_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "registry_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.385,
    y: 18.682,
    width: 33.231,
    height: 23.405,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.385,
    y: 18.682,
    width: 33.231,
    height: 23.405,
    rx: 1,
    stroke: "#4F6BCB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    mask: "url(#registry_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "registry_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13.143,
    width: 8,
    height: 28.944,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13.143,
    width: 8,
    height: 28.944,
    rx: 1,
    stroke: "#4F6BCB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    mask: "url(#registry_svg__c)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.462 13.143c0-1.53-1.55-2.77-3.461-2.77-1.912 0-3.462 1.24-3.462 2.77",
    stroke: "#4F6BCB",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.714 10.571a6.154 6.154 0 00-.376-.415c-1.044-1.053-2.702-2.017-4.743-2.564-2.04-.546-3.959-.54-5.39-.15-1.464.4-2.175 1.112-2.358 1.797-.183.685.075 1.659 1.144 2.737.405.409.903.804 1.48 1.167h-2.068C8.975 11.841 8.266 10.31 8.64 8.916c.692-2.585 4.847-3.718 9.279-2.531 2.814.754 5.064 2.263 6.154 3.927 1.09-1.664 3.34-3.173 6.154-3.927 4.432-1.187 8.586-.054 9.28 2.53.373 1.395-.337 2.926-1.764 4.228h-2.069a8.325 8.325 0 001.48-1.167c1.07-1.079 1.328-2.052 1.145-2.737-.184-.685-.895-1.398-2.36-1.797-1.43-.39-3.348-.396-5.388.15-2.04.547-3.7 1.511-4.743 2.564a6.087 6.087 0 00-.408.454 4.195 4.195 0 00-1.4-.236c-.454 0-.888.07-1.286.197z",
    fill: "#4F6BCB"
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgRegistry as ReactComponent };